import styles from './Profile.module.scss';

import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';

import { withRouter } from 'next/router';

import User from './User/User';
import ProfileSettings from './ProfileSettings/ProfileSettings';

import { getUser, getMyProfile } from 'legacy/actions/userActions';
import Loader from 'legacy/common/components/layout/Loader';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

interface ProfileProps {
  user: any;
  users: any;
  router: any;
  device: any;
  getUser: (id: string) => void;
  getMyProfile: () => void;
  userLoading: boolean;
  userError: any;
}

const Profile = ({
  user,
  users,
  router,
  device,
  getUser,
  getMyProfile,
  userLoading,
  userError
}: ProfileProps) => {
  const { query } = router;
  const { slug = [], view } = query;
  const [id] = slug;

  const isSettings = view === 'settings';

  useEffect(() => {
    getMyProfile();

    if (id) {
      getUser(id);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getUser(id);
    }
  }, [id]);

  const profileToDisplay = !isSettings && id ? users[id] : user;

  if (userError?.type === 'NotFoundError') {
    return <NotFoundPage />;
  }

  return (
    <Loader isOverlay isLoading={userLoading}>
      <div className={classnames([styles.Profile], device)}>
        {isSettings && profileToDisplay ? (
          <ProfileSettings user={profileToDisplay} />
        ) : (
          <User _id={id || ''} user={profileToDisplay || {}} onMount={null} />
        )}
      </div>
    </Loader>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  users: state.user.users,
  device: state.app.device,
  orgs: state.orgs.orgs,
  userLoading: state.user.loading.GET_USER,
  userError: state.user.errors.GET_USER
});

const actions = { getUser, getMyProfile };

export default withRouter(connect(mapStateToProps, actions)(Profile));
